import moment from "moment";
import React, { useState } from "react";
import FilterToolbar from "../inputs/FilterToolbar";
import { Alert, Badge, Button, Modal, Pagination, Table } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, TICKETS } from "../../config/apiConfig";
import { IoMdSearch } from "react-icons/io";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useForm } from "react-hook-form";
import Input from "../inputs/Input";
import { AiOutlineLoading } from "react-icons/ai";
import TextAreaInput from "../inputs/TextAreaInput";
import EmptyTable from "./EmptyTable";

const HelpCenterTable = () => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isOpen, setOpenModal] = useState(false);
  const [isOpenView, setOpenModalView] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);

  const {
    isLoading: isLoadingTickets,
    error: errorListTickets,
    data: listTickets,
  } = useQuery(["listTickets", currentPage], async () => {
    try {
      const { data } = await axios.get(
        `${TICKETS.GET_ALL}?page=${currentPage}`
      );
      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);
      return data.data.data;
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
      throw new Error("Erro ao buscar dados.");
    }
  });

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    setError,
    watch,
    control,
    formState: { errors },
    clearErrors,
  } = useForm();

  const handleSubmitNewTicket = async (data) => {
    setIsSubmitting(true);
    setErrorSubmit(false);
    try {
      await axios.post(TICKETS.CREATE, data);
      reset();
      setOpenModal(false);
      queryClient.invalidateQueries("listTickets");
    } catch (error) {
      setErrorSubmit(true);
    } finally {
      setIsSubmitting(false);
    }
    console.log(data);
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setOpenModalView(true);
  };

  return (
    <>
      <div className="flex flex-col md:flex-row justify-end mb-3 mt-2 items-end md:items-center gap-2">
        <Button className="primary" onClick={() => setOpenModal(true)}>
          Criar novo chamado
        </Button>
      </div>
      <form
        className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
        onSubmit={handleSearchName}
      >
        <input
          type="text"
          placeholder="Busque por número do chamado..."
          className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>
      <small
        className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
        style={{ fontSize: 10 }}
      >
        <span>Deslize para o lado para visualizar todas as informações</span>{" "}
        <FaArrowsLeftRight />
      </small>
      <div className="overflow-x-auto shadow-sm rounded-lg mt-0 md:mt-5">
        <Table striped>
          {listTickets?.length > 0 || isLoadingTickets ? (
            <Table.Head>
              <Table.HeadCell className="bg-gray-300 py-2 text-center">
                Nº Chamado
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Data
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Título
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Status
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Ações
              </Table.HeadCell>
            </Table.Head>
          ) : (
            <></>
          )}

          <Table.Body className="divide-y">
            {!isLoadingTickets ? (
              <>
                {listTickets?.length > 0 ? (
                  <>
                    {listTickets?.map((support, index) => (
                      <Table.Row
                        key={index}
                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                      >
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          #{support.id}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {moment(support.createdAt).format("DD/MM/yyyy") ||
                            "Não informado"}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support.title}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support.status == 0 ? (
                            <Badge className="w-fit mx-auto" color="warning">
                              Pendente
                            </Badge>
                          ) : support.status == -1 ? (
                            <Badge className="w-fit mx-auto" color="failure">
                              Cancelado
                            </Badge>
                          ) : support.status == 1 ? (
                            <Badge className="w-fit mx-auto" color="success">
                              Em andamento
                            </Badge>
                          ) : (
                            <Badge className="w-fit mx-auto" color="success">
                              Concluído
                            </Badge>
                          )}
                        </Table.Cell>
                        <Table.Cell className="text-center py-2">
                          <div className="flex gap-2 justify-center">
                            <Tooltip
                              id="tooltip-view-details"
                              content="Visualizar detalhes"
                            />
                            <div className="flex gap-1 justify-center items-center flex-wrap">
                              <MdOutlineRemoveRedEye
                                data-tooltip-id="tooltip-view-details"
                                fontSize="16"
                                onClick={() => handleViewTicket(support)}
                                className="cursor-pointer text-gray-500"
                              />
                            </div>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </>
                ) : (
                  <div>
                    <EmptyTable icon="help_center">
                      Nenhum chamado aberto
                    </EmptyTable>
                  </div>
                )}
              </>
            ) : (
              <TableLoading cols={5} />
            )}
          </Table.Body>
        </Table>
      </div>

      {totalCount > 0 && (
        <div className="mt-3 text-center text-sm">
          Foram encontrados {totalCount} registros no total
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex overflow-x-auto justify-center mt-3">
          <Pagination
            layout="pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel=""
            nextLabel=""
            showIcons
          />
        </div>
      )}

      <Modal show={isOpen} size="2xl" onClose={() => setOpenModal(false)} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <div>
              <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-6">
                Abrir um chamado
              </h3>
              <form onSubmit={handleSubmit(handleSubmitNewTicket)}>
                <div className="flex flex-col gap-4">
                  <Input
                    required={true}
                    name="title"
                    label="Título *"
                    register={register}
                  />
                  <TextAreaInput
                    name="description"
                    label="Descrição *"
                    register={register}
                    required={true}
                  />
                </div>

                {errorSubmit && (
                  <Alert withBorderAccent color="failure" className="mt-4 mb-2">
                    Ops! Ocorreu um erro ao tentar criar o chamado. Tente
                    novamente mais tarde!
                  </Alert>
                )}

                <Button
                  type="submit"
                  className="bg-primary mt-4 w-full"
                  processingSpinner={
                    <AiOutlineLoading className="h-6 w-6 animate-spin" />
                  }
                  isProcessing={isSubmitting}
                  disabled={isSubmitting}
                >
                  Abrir chamado
                </Button>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={isOpenView}
        size="2xl"
        onClose={() => setOpenModalView(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-left">
            <div className="">
              {selectedTicket?.status == 0 ? (
                <Badge className="inline-block" color="gray">
                  Pendente
                </Badge>
              ) : selectedTicket?.status == -1 ? (
                <Badge className="inline-block" color="failure">
                  Cancelado
                </Badge>
              ) : selectedTicket?.status == 1 ? (
                <Badge className="inline-block" color="info">
                  Em andamento
                </Badge>
              ) : (
                <Badge className="inline-block" color="success">
                  Concluído
                </Badge>
              )}
              <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-2 mt-2">
                Chamado: #{selectedTicket?.id}
              </h3>
              <div className="mb-2">Título: {selectedTicket?.title}</div>
              <div>Descrição: {selectedTicket?.description}</div>
              <Button
                className="mt-4 mx-auto primary"
                onClick={() => setOpenModalView(false)}
              >
                Fechar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HelpCenterTable;
